<template>
  <div id="earlyBus">
    <div class="img_earlyBus">
      <img class="bull_main" src="../assets/img/linkPage/LPearlyBus.jpg" alt="" @click="goToDetail()" style="cursor: pointer;">
      <img class="bull_main_mo" src="../assets/img/linkPage/LPearlyBus.jpg" alt="" @click="goToDetail()" style="cursor: pointer;">
    </div>
  </div>
    
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      
    };
  },
  created() {
    this.bSeq = this.$route.query.bSeq;
  },
  computed: {
    user() {
      return this.$store.state.user;
    }   
  },
  methods: {
    goToDetail() {
      this.$router.push({ path: "/bustour", query: { nt: "JP", ar: "OSA" } });
    }
  },
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Hahmlet:wght@300;400;500;700&display=swap');

#earlyBus {
  display: flex;
  justify-content: center; /* 가로 중앙 */
  align-items: center;     /* 세로 중앙 */
}

.img_earlyBus{
  width: 1200px;
}

@media (max-width:767px){
  .bottom_btn{
    margin: 0 auto;
    height: 100px;
  }
}
</style>